export const BATCH_SIZE = 2000
export const SERVER_ORIGIN = window.location.origin
export const REALTIME_UPDATES = false
